export default {
  line: "Линия",
  language: "Язык",
  common: [
    "Онлайн-сервисы",
    "Отменить приостановку",
    "Стоит ли тратить 10 000 ₽ на покупку!"
  ],
  charitables: [//慈善
    "Добро пожаловать в официальный информационный центр SGM! 🌟 Ваша платформа для прозрачной и достоверной информации. Здесь вы можете ознакомиться с нашими официальными сертификатами 📜, посетить сайт https://sgm-tm.com/ для получения полной информации 🌐 и подписаться на наш канал WhatsApp, чтобы быть в курсе последних новостей! 📲 Кроме того, вы найдете положительные отзывы о SGM от международных СМИ, таких как Yahoo, Associated Press и Google! 📰 Всё это значительно повысит вашу уверенность в бренде SGM и его дальнейшем развитии, помогая вам добиться успеха в сфере совместного транспорта и стабильно получать существенный дополнительный доход! 💰🚀"
  ],
  details: [
    "Цена за единицу задачи",
    "Количество заказов",
    "Ежедневный доход",
    "Уровень",
    "Ежедневная прибыль",
    "Депозит",
    "Дата возврата депозита",
    "Осталось дней",
    "Мой уровень SGM"
  ],
  upload: [
    "Загрузка...",
    "Неправильный формат",
    "Загрузка выполнена успешно",
    "Ошибка загрузки"
  ],
  vanPull: [
    "Больше данных нет",
    "Нет данных"
  ],
  login: {
    title: 'Войти с именем пользователя и паролем',
    title_txt: 'Войдите в систему, используя зарегистрированный номер мобильного телефона.',
    text: [
      "Запомнить имя пользователя/пароль",
      "Ведение журнала...",
      "Войти сейчас"
    ],
    placeholder: [
      "Пожалуйста, введите номер телефона",
      "Пожалуйста, введите пароль для входа"
    ],
    i18n: [
      "Нет аккаунта {title}? {a} {line}",
      "Зарегистрироваться"
    ]
  },
  register: {
    text: [
      "Добро пожаловать на регистрацию",
      "отправка СМС-кода...",
      "Получить СМС-код",
      "Регистрация...",
      "Зарегистрируйтесь сейчас",
      "У вас уже есть аккаунт? Войти сейчас",
      "Регистрация номера мобильного телефона",
      "Регистрация по электронной почте",
      "Вернуться к входу",
      "Пожалуйста, используйте незарегистрированный номер телефона и адрес электронной почты."
    ],
    placeholder: [
      "Пожалуйста, введите ваш номер телефона",
      "Пожалуйста, введите код подтверждения SMS",
      "Пожалуйста, введите пароль для входа",
      "Пожалуйста, подтвердите свой пароль",
      "Пожалуйста, введите код приглашения",
      "Два разных пароля",
      "Пожалуйста, введите проверочный код",
      "Пожалуйста, введите номер электронной почты",
      "Не может начинаться с 0"
    ],
    i18n: [
      "Есть аккаунт? {a} {line}",
      "Авторизоваться"
    ]
  },
  home: {
    lucky: "Мероприятие еще не открыто",
    map: "Расположение",
    qywh: "Корпоративная культура",
    broadcast: "Поздравляем пользователя {member} с приглашением друга присоединиться к онлайн-программе проката велосипедов SGM, повышением до {vipname} и получением вознаграждений за прокат велосипедов {grade}..",
    menu: [
      "VIP-зона",
      "Видеоурок",
      "Награды за продвижение по службе"
    ],
    taskHall: {
      title: [
        "Зал задач",
        "Бизнес-холл",
        "Выполняйте задания, чтобы получать прибыль"
      ]
    },
    title: ['Задача', 'Новости', 'более', 'разблокировать', 'Пожалуйста, разблокируйте и продолжайте использовать~', 'Проверить', 'Поздравляем! Обновление прошло успешно.', 'Поздравляю~ получил две открытки'],
    memberList: {
      title: "Список членов",
      data: [
        "{member}, выполни {num} сегодняшних заданий заказа!"
      ]
    },
    businessList: {
      title: "Список торговцев",
      data: [
        "{member}",
        "Выполнить {num} одну задачу сегодня"
      ]
    },
    noticeTitle: ["Уведомление", "Предыдущий", "Следующий"],
    tabBar: ["Дом", "Доставка", "T", "Карта", "Мой"],
    msg: "Задача не открыта",
    video: "Видеоурока нет",
    message: "У вас есть новые новости",
    bonus: [
      '<p>Введите код, чтобы получить "Кодекс велосипедистов" денежное вознаграждение (1-200000 TJS)</p><p>1. "Кодекс велосипедистов" получено в результате деятельности компании!</p><p>2. Рабочая группа время от времени выпускает пароли! Вы можете следить за информацией о рабочей группе ежедневно.!</p><p>Используйте велосипеды, наслаждайтесь жизнью в экономике совместного потребления и легко получайте вознаграждения за коды!</p><p>Подробную информацию можно найти на сайте "Менеджер по рынку"</p>',
      'Пароль получен в результате деятельности компании.!',
      'Введите код красного конверта',
      'Получить наличные',
      'Поздравляем с победой в Ride Cash {amount}TJS',
      'Ride Cash'
    ]
  },
  vip: {
    title: [
      "VIP-уровень",
      "Присоединяйтесь к членству сейчас, чтобы получать задания",
      "В разработке"
    ],
    user: {
      title: [
        "Ваша личность",
        "Посетители"
      ],
      label: "Ежедневные задачи",
      value: [
        "Дата вступления в силу",
        "Один год",
        "Пожалуйста, сначала войдите в систему",
        "Срок действия стажировки",
        "Обратный отсчет возврата депозита",
        "Обратный отсчет срока действия VIP-уровня"
      ],
    },
    list: {
      label: "Ежедневный заказ:{number}",
      button: "Присоединяйтесь сейчас",
      text: [
        "Ежедневная прибыль",
        "Ежемесячный доход",
        "Награда за набор: всем",
        "Бесплатно",
        "За заказ",
        "Рейтинг дохода",
        "Эффективная доходность",
        "Дата окончания срока",
        "Год",
        "День",
        "Срок действия"
      ],
    },
    dialog: [
      "Вы уверены, что потратите {currency} {amount}, чтобы стать {name}?",
      "В настоящее время вы {currname} и не можете быть {name}",
      "Вы уверены, что потратите {currency} {amount} на продление {name}??",
    ],
    index: ["Отмена", "Подтверждать"],
    desc: [
      '{level} Преимущества',
      'Базовый доход',
      'Время',
      'Номер доставки',
      'Доход',
      'Ежедневно',
      'Ежемесячно',
      'Ежегодно',
      'Доход от набора персонала',//8
      'Подчиненный уровень',
      'Коэффициент комиссии за набор персонала',
      'Бонус за набор персонала',
      'Подчиненный 1-го уровня',
      "Подчиненный 2-го уровня",
      "Подчиненный 3-го уровня",
      'Скидка за доставку за один день',
      'Подчиненный уровень',
      'Коэффициент скидки на подчиненную доставку',//17
      'Сумма скидки за доставку',
      'Подчиненный 1-го уровня',
      'Подчиненный 2-го уровня',
      'Подчиненный 3-го уровня',
      '3 дня',
      'Цена за единицу доставки',
      'Подробности испытательного срока',//24
      'Пробный период: Покупка не требуется. Выставляйте велосипеды общего пользования дважды в день, с комиссией 3 TJS за каждое использование, всего 6 TJS в день. Бесплатный пробный период 2 дня.',
      'Пример поручения на выполнение задания:',
      '<p>Партнеры уровня 1, которые выполняют заказы поездок на сумму 10 000 TJS в день, получат комиссию в размере 300 TJS.</p><p>Партнеры уровня 2, которые выполняют заказы поездок на сумму 10 000 TJS в день, получат комиссию в размере 200 TJS.</p><p>Партнеры уровня 3, которые выполняют заказы поездок на сумму 10 000 TJS в день, получат комиссию в размере 100 TJS.</p>',
      'Описание реферального бонуса:',
      '<p>(Подчиненный 1-го уровня) Вы напрямую приглашаете A присоединиться, A — ваш подчиненный 1-го уровня.</p><p>(Подчиненный 2-го уровня) A приглашает B присоединиться, B — ваш подчиненный 2-го уровня.</p><p>(Подчиненный 3-го уровня) B приглашает C присоединиться, C — ваш подчиненный 3-го уровня.</p><p>Примечание: реферальный бонус можно запросить только для максимального бонуса текущего уровня лица.</p>',
    ]
  },
  charitable: [
    'Инициатива зеленой благотворительности',
    'Компания SGM считает благотворительность и общественное благосостояние своей корпоративной миссией. Мы регулярно жертвуем товары и средства малообеспеченным сообществам, людям с ограниченными возможностями и школам, а также сотрудничаем с неправительственными организациями в рамках проектов по развитию экологичной мобильности и охране окружающей среды..',
    'Каждый велосипед, который мы предоставляем в пользование, представляет собой благотворительное пожертвование, помогая городам сокращать выбросы, а также распространять тепло..',
    'Мы поддерживаем дух "велосипедизма, благотворительности и взаимовыгодного сотрудничества" и зажигаем надежду нашими колесами. Мы искренне приглашаем вас присоединиться к SGM, ехать за экологичное будущее и дарить любовь..',
    'Мы призываем вас активно участвовать в общественных благотворительных инициативах и вместе дать возможность любви и зелени процветать в каждом уголке города..'
  ],
  lucky: {
    default: [
      "Счастливая педаль",
      "Оставшееся количество розыгрышей:",
      "Рекорд лотереи",
      "Правила лотереи",
      "<p>Участвуйте в мероприятиях компании и получайте шанс поучаствовать в розыгрыше призов!</p>",
      "Рекорд победителя среди пользователей",
      ['Поздравляем:{member}', 'Получите призы {profit}'],
      "Поздравляем,получаем призы ",
      "закрывать",
      "Ваше время розыгрыша истекло",
      "Действительно до"
    ],
    scattered: [
      'Количество розыгрышей',
      'Поездка',
      '<p>1. Количество розыгрышей определяется деятельностью компании!</p><p>2. Каждый розыгрыш занимает 1 розыгрыш!</p><p>3. После выигрыша физического приза, пожалуйста, свяжитесь с менеджером по подбору персонала, чтобы зарегистрировать свои данные и получить приз!</p>',
      'Напоминание',
      'Важные напоминания',
      'Право на участие в розыгрыше',
      'Получите шансы на розыгрыш призов благодаря деятельности компании',
      'Правила жеребьевки',
      '1 бросок потрачен за попытку',
      'Получение приза',
      'Обратитесь к менеджеру по подбору персонала для получения физических призов'

    ],
    prizeList: [
      'Призовой фонд Lucky Pedal',
      '52 TJS Наличные',
      'Мгновенный вывод средств',
      '88 TJS Наличные',
      '205 TJS Наличные',
      '19 889 TJS Наличные',
      '236 666 TJS наличными',
      'Android-телефон',
      'Стоимостью 8000 TJS',
      'Ваучер на обновление',
      'Стоимость 600 TJS',
      'Двойные заказы',
      'Ежедневно',
      'Эксклюзивный внешний аккумулятор компании SGM',
      'стоимостью 1000 TJS',
      'Механический велосипед',
      'Стоимостью 3000 TJS',
      'Электромопед',
      'Стоимостью 80 000 TJS',
      'айфон 17',
      'Стоимостью 160 000 TJS'
    ],
  },
  moments: [
    'Ежедневные обновления',
    'Официальная платформа для сотрудников SGM, где можно делиться доходами от использования велосипедов, участвовать в благотворительных акциях и делиться прекрасными моментами. Обновляйте ежедневно в течение 3 дней подряд, чтобы участвовать в розыгрышах денежных призов (от 1 до 200 000 TJS). Присоединяйтесь к товарищам по команде, чтобы дарить любовь и сделать каждую поездку более ценной!'
  ],
  userLc: {
    default: [
      "Велосипедное богатство",
      "Записи",
      "Количество",
      "Срок хранения",
      "Сумма депозита",
      "Пожалуйста, введите сумму депозита",
      "Доход",
      "Представлять на рассмотрение",//7
      "Пожалуйста, сначала выберите продукт",
      "Пожалуйста, выберите информацию",
      "Выгода",
      "День",
      "нет данных",
      "Время покупки",
      "состояние",
      "Конец Времени",
      "Баланс",
      "Сегодняшний доход",
      "Покупка в один клик"//18
    ],
    tabs: [
      "Список продуктов",
      "Рекорд сбережений"
    ],
    tips: '<p>VOISP "Wealth Enhance" — это способ компании предоставить всем сотрудникам уровня M больше возможностей для увеличения дохода. Инвестиционные проекты — это совместные финансовые инвестиционные проекты PAGE, банков, компаний по управлению активами и других компаний!</p><p>Краткосрочные инвестиции: стабильный доход, гибкий выбор цикла! Краткосрочные свободные средства могут принести дополнительный доход за счет инвестиций! Долгосрочные инвестиции: более высокая доходность, создание хороших регулярных инвестиционных сбережений, получение более высокой доходности и реализация ваших мечтаний путем накопления!</p>'
  },
  newlist: {
    text: [
      "Нет записей",
      "Ожидаемый доход",
      "результаты",
      "выиграть время",
      "статус",
      "Конец времени"
    ],
    placeholder: [
      "больше нет данных",
      "нет данных"
    ],
    i18n: [
      "История покупок",
    ],
    title: [
      "План сбережений Cycling Wealth Green — специальная льгота, разработанная специально для штатных сотрудников SGM.!",
      "Ваши средства контролируются и авторизуются финансовыми учреждениями, такими как сберегательные банки, и являются абсолютно безопасными и надёжными. SGM сотрудничает со многими ведущими банками, предлагая широкий спектр сберегательных продуктов с гибкими условиями и различными вариантами доходности для достижения ваших финансовых целей на всех этапах.",
      "Мы не только призываем вас активно участвовать в велосипедном движении и использовать низкоуглеродный транспорт, но и надеемся, что вы будете разумно планировать свои личные финансы, внося свой вклад в более экологичное будущее. SGM гордится тем, что идёт вместе с вами, открывая новую главу в истории экологического благосостояния.!"
    ]
  },
  product: {
    default: [
      "Баланс промо-акции",
      "Первоначальная сумма сбережений",
      "Максимальная сумма сбережений",
      "Цикл",
      "Ежедневная процентная ставка",
      "максимум",
      "Правила проекта",
      "Сумма проекта",
      "Способ оплаты",
      "Первоначальная сумма сбережений",
      "Ежедневная прибыль",
      "Цикл выпуска",
      "Предполагаемый доход"
    ],
    placeholder: [
      "Возврат основного долга и дохода по истечении срока (обычно в праздничные дни)",
      ", автоматический расчет в течение 24 часов",
      "{str} = общий доход {income} {currency} + основной долг {money} {currency} = общий основной долг и проценты {total} {currency}",
      "Пароль безопасности"
    ]
  },
  user: {
    vipl: "Уровень партнера",
    hello: "Добро пожаловать",
    default: [
      "Мой руководитель",
      "Счёт",
      "Код приглашения",
      "Выйти из системы",
      "Баланс",
      "Золото",
      "Мой кошелёк",
      "Печать",
      "Ограничение",
      "Хорошо",
      "Отлично",
      "Активировать Помощника по чтению",
      "Связаться с менеджером по найму",
      "Операционные расходы"
    ],
    myEarnings: {
      grid: ["Баланс", "Вчерашние доходы", "Сегодняшний доход", "Доходы этой недели", "Доходы этого месяца", "Доход за прошлый месяц", "Общий доход", "Выполните задачу сегодня (PCE)", "Оставшиеся задачи на сегодня (PCE)", "Сегодняшняя комиссия", "Скидка за доставку", "Скидка за рефералов"]
    },
    grid: [
      "Баланс",
      "Вчерашний доход",
      "Сегодняшний доход",
      "Доход за эту неделю",
      "Доход за этот месяц",
      "Доход за прошлый месяц",
      "Общий доход",
      "Выполнить задание сегодня (PCE)",
      "Оставшиеся задания на сегодня (PCE)",
      "Сегодняшняя комиссия",
      "Сегодняшняя скидка"
    ],
    menu: [
      "Записи задач",
      "Задание аудита",
      "Управление релизами",
      "Личная информация", //3
      "Привязка к аккаунту",
      "Ежедневная выписка",
      "Бухгалтерские записи", //6
      "Общее приглашение",
      "Отчёты команды", //8
      "Справочное руководство", //9
      "Кредитный рейтинг", //10
      "Скачать приложение", //11
      "Счастливая педаль", //12
      "Cycling Wealth",
      "Помощник по чтению",
      "Корпоративная культура",
      "Видеоинструкция",
      "Отличная команда",
      "Cycling Wealth",
      "Следите за SGM",
      "Награды за рост",
      "Кодекс велосипедиста",
      "Педаль по делам"
    ],
    positions: [
      "Моя должность",
      "Текущая должность",
      "Следующая должность",
      "Непосредственно аффилированный сотрудник уровня M",
      "Участник команды уровня M 3",
      "Команда уровня 3 (номер должности {post})",
      "Выполните все требования, чтобы связаться с менеджером по найму для повышения вашей должности!",
      "Описание должности",
      "Откликнуться на должность",
      "Информация о должности"
    ],
    office: [
      "Информация о моей вакансии",
      "Подробности о повышении в должности",
      "Описание вакансии SGM",
      "Должность в компании",
      "Повышение в должности",
      "Подать заявку",
      "Ход повышения в должности",
      "Как минимум",
      "Условия не выполнены", //8
      "Участники трёхуровневой команды (1/2/3) должны стать ({name}).",
      "В команде должно быть более ",
      " участников"
    ],
    current: [
      "Текущие должности",
      "Всего VIP-участников"
    ],
    subordinate: [
      "1-й уровень",
      "2-й уровень",
      "3-й уровень",
      "список участников",
      "всего людей",
      "общий доход",
      "сумма вывода",
      "доход команды",
      "список участников",
      "пользователь",
      "уровень",
      "время присоединения",
      "пробный период"
    ],
    follow: [
      "Официальный канал SGM",
      "Подпишитесь на канал, чтобы узнать больше о последних новостях SGM.!"
    ]
  },
  userInfo: {
    default: [
      "Личная информация",
      "Фотография головы",
      "Номер мобильного телефона",
      "Добавить банковский счёт",
      "Alipay",
      "Настоящее имя",
      "Пароль для входа",
      "Пароль для входа в систему",
      "Нажмите Настройки",
      "Изменить фотографию головы",
      "Изменить пароль для входа в систему",
      "Изменить пароль для входа в систему",
      "Отправить",
      "Очистить кэш",
      "Выйти"
    ],
    label: [
      "Исходный пароль для входа",
      "Новый пароль для входа",
      "Подтверждение паролей",
      "Исходный денежный код",
      "Новый денежный код",
      "Подтверждение пароля"
    ],
    placeholder: [
      "Пожалуйста, введите исходный пароль для входа",
      "Пожалуйста, введите новый пароль для входа",
      "Подтвердите пароль для входа.",
      "Пожалуйста, введите исходный пароль фонда",
      "Пожалуйста, введите новый пароль для доступа к средствам",
      "Пожалуйста, подтвердите пароль фонда"
    ]
  },
  userSet: {
    default: [
      "Подтверждение подлинности имени",
      "Подробная информация",
      "Привязать Alipay",
      "Отправить"
    ],
    label: [
      "Настоящее имя",
      "QQ",
      "Счёт Alipay",
      "Имя в Alipay"
    ],
    placeholder: [
      "Пожалуйста, введите настоящее имя (Моё имя используется для снятия наличных)",

      "Введите номер QQ",

      "Пожалуйста, введите номер счёта Alipay",

      "Пожалуйста, введите имя в Alipay"
    ],
    tips: "Напоминание: привязанная банковская карта не может быть изменена, она используется для вывода средств."
  },
  bindAccount: {
    default: [
      "Привязать аккаунт",
      "Посмотреть руководство",
      "Отправить"
    ],
    tabs: [
      "Счет",
      "Счет",
      "Счет"
    ],
    label: [
      "Инструкции",
      "Добавить скриншот",
      "Счет"
    ],
    placeholder: "Пожалуйста, введите ваш {account} аккаунт"
  },
  bankCard: {
    default: [
      "Привязать банковскую карту",
      "Аутентифицировать сейчас",
      "Отправка...",
      "Добавить сейчас",
      "Добавить банковскую карту"
    ],
    tips: [
      "Перед добавлением банковской карты пройдите аутентификацию по настоящему имени.",
      "Имя пользователя на вашей банковской карте должно совпадать с реальным именем, которое вы подтвердили, в противном случае вы не сможете успешно снять наличные.."
    ],
    label: [
      "Имя",
      "Название банка",
      "Номер банковского счета",
      "Код филиала",
      "IFSC"
    ],
    placeholder: [
      "Пожалуйста, выберите название банка",
      "Пожалуйста, введите номер банковского счета",
      "Пожалуйста, введите код филиала",
      "Подтверждать",
      "Отмена",
      "Пожалуйста, введите IFSC"
    ]
  },
  wallet: {
    default: [
      "Мой кошелек",
      "Пополнение",
      "Снятие",
      "История пополнения",
      "История снятия",
      "R",
      "W",
      "Пополнение ₽"
    ],
    label: [
      "Способ вывода",
      "Сумма вывода",
      "Пароль фонда",
      "Отправить",
      "Номер телефона",
      "Электронная почта",
      "IFSC",
      "Способ оплаты",
      "Налогообложение",
      "Фактическая полученная сумма"
    ],
    placeholder: [
      "Выберите способ вывода средств",
      "Пожалуйста, введите сумму вывода",
      "Пожалуйста, введите пароль фонда",
      "Пожалуйста, выберите способ вывода средств",
      "Пожалуйста, введите номер мобильного телефона получателя платежа.",
      "Введите адрес электронной почты получателя платежа.",
      "Пожалуйста, введите получателя платежа IFSC",
      "Пожалуйста, выберите способ оплаты"
    ],
    msg: [
      "Вы еще не установили пароль для фонда. Пожалуйста, сначала установите его.",
      "Вы еще не привязали свою банковскую карту, пожалуйста, сначала привяжите ее.",
      "<p>Время вывода средств:</p><p>Понедельник: M9</p><p>Вторник: M8</p><p>Среда: M6/M7</p><p>Четверг: M3/M4/M5</p><p>Пятница: M1/M2</p><p>(Стажеры с понедельника по воскресенье)</p><p>с 9:00 до 18:00</p>"
    ]
  },
  recharge: {
    default: [
      "Пополнение",
      "Данные пополнения",
      "Запись пополнения",
      "Доступный баланс {money}, выберите способ пополнения",
      "Минимальная сумма пополнения: {currency} {min}, максимальная: {currency} {max}, комиссия за обработку: {fee}%",
      "Отправка...",
      "Пополнение сейчас",
      "Возврат",
      "Загрузка...",
      "Минимальная сумма пополнения: ${min}, максимальная: ${max}, комиссия за обработку: {fee}%"
    ],
    label: [
      "Сумма пополнения",
      "Канал пополнения",
      "Название перевода",
      "Имя плательщика",
      "Мобильный телефон плательщика",
      "Счёт UPI плательщика",
      "Электронная почта плательщика",
      "Порядок транзакции"
    ],
    placeholder: [
      "Введите сумму пополнения",
      "Выберите способ пополнения",
      "Введите название перевода",
      "Минимальная сумма единовременного перевода: {currency} {min}",
      "Максимальная сумма единовременного перевода: {currency} {max}",
      "Введите имя плательщика",
      "Введите номер мобильного телефона плательщика",
      "Введите номер счета UPI плательщика",
      "Введите адрес электронной почты плательщика",
      "Загрузите скриншот перевода",
      "Введите номер заказа на транзакцию"
    ],
    info: [
      "Сумма пополнения",
      "Номер заказа",
      "Банк",
      "Номер счета",
      "Имя",
      "Копия",
      "Перевод {type}",
      "Скриншот перевода",
      "Отправить",
      "Код IFSC",
      "Тип счета",
      "Инструкции по обработке"
    ],
    tips: [
      "Пожалуйста, выберите следующий способ перевода соответствующей суммы, чтобы избежать задержек при финансовой проверке.<br>После перевода, пожалуйста, загрузите скриншот перевода в качестве подтверждения",
      "Не нужно добавлять друзей, отсканируйте QR-код, чтобы перевести мне деньги",
      "Пожалуйста, завершите перевод в соответствии с информацией ниже",
      "Подсказка: После успешного платежа, пожалуйста, свяжитесь с онлайн-сервисом, чтобы сообщить номер вашего счета участника, сумму пополнения, номер заказа, номер счета вкладчика, время пополнения и удобное для финансового отдела время для своевременного зачисления средств",
      "Примечание: Пожалуйста, отправляйте один платеж за каждый перевод",
      "После перевода, пожалуйста, загрузите скриншот перевода в качестве подтверждения",
      "Совет: После успешного платежа, пожалуйста, загрузите фотографию успешной транзакции",
      "<p>Напоминание о пополнении счета: Ознакомьтесь с ним перед пополнением счета.</p><p>1: Пожалуйста, оплачивайте согласно последнему счету пополнения.</p><p>2: Срок действия платежа составляет 10 минут. Пожалуйста, завершите платеж в течение 10 минут. Если платеж не будет произведен в течение 10 минут, счет получателя будет недействителен. Пожалуйста, повторно получите последний счет пополнения для оплаты.</p><p>3: Сумма перевода должна соответствовать отправленной вами сумме.</p><p>4: Если платеж не прошел, пожалуйста, не сохраняйте предыдущий счет получателя. Пожалуйста, повторно отправьте заказ на пополнение счета, чтобы получить последний счет, в противном случае ваш платеж будет считаться недействительным.</p><p>5: Если платеж прошел успешно, пожалуйста, отправьте UTR в соответствии с требованиями для обеспечения своевременной проверки финансовым отделом.</p>"
    ]
  },
  postTask: [
    "название",
    "Выберите изображение",
    "Доставить",
    "Введите название задачи"
  ],
  task: {
    default: [
      "СПИСОК ПОСТАВКИ",
      "Требования к задаче",
      "Создать",
      "Аудит",
      "Открыть ссылку",
      "Копировать ссылку",
      "Цена за единицу",
      "Отправить",
      "Отказ",
      "Начать обслуживание",
      "В процессе",
      "НАЧАТЬ РАЗВЕРТЫВАНИЕ"
    ],
    tabs: [
      "Выполняется",
      "Аудит",
      "Завершено",
      "Провалено",
      "Вредоносный",
      "Отказано"
    ],
    msg: "Сегодняшняя миссия выполнена.",
    msgSc: "Успешно получено",
    msgTime: "После окончания обратного отсчета задача будет выполнена автоматически, и ее досрочное закрытие будет недействительным.!",
    info: [
      "Подробности задачи",
      "Название задачи",
      "Преимущества задачи",
      "Описание задачи",
      "Загрузить требования",
      "Отправить образец",
      "Пользователь не предоставил образец",
      "Примечания к аудиту",
      "Дата аудита",
      "Сторона спроса",
      "Выпуск",
      "Копировать",
      "Перейти",
      "Шаги задачи",
      "Шаг {index}",
      "Пример аудита",
      "Нет примера аудита",
      "Загрузка данных...",
      "Отказаться от задачи",
      "Отправить выполненное задание",
      "Опубликовать контент"
    ],
    index: [
      "Текущий статус",
      "Ваш текущий рейтинг: <i style=\"color:#1989fa\">{currVip}</i><br>можно выполнить только задание текущего уровня <i style=\"color:#1989fa\">{currVip}</i><br>Вы хотите присоединиться к уровню <i style=\"color:#dd6161\">{vip}</i>?",
      "Присоединиться сейчас",
      "Выберите категорию задания",
      "Отмена",
      "Осталось",
      "Бесплатная доставка",
      "В разработке"
    ],
    list: [
      "Список задач",
      "Спрос",
      "Остаток",
      "Запрос",
      "Получение"
    ],
    show: [
      "Детали задачи",
      "Время покупки",
      "Статус доставки",
      "Стоимость аренды",
      "Время доставки",
      "Обратный отсчёт до получения",
      "Начать обслуживание",
      "Кодирование",
      "НЕ ЗАКОНЧЕНО"
    ]
  },
  postRecord: [
    "Ежедневные обновления",
    "Выпуск",
    "Итого",
    "Завершено",
    "Срок",
    "Аудит",
    "Аннулирование",
    "Редакторы",
    "Ежедневные обновления",
    "Получить",
    "Центр объявлений SGM",
    "Информационный центр"
  ],
  dayReport: [
    "Ежедневная выписка",
    "Общий доход",
    "Моя комиссия",
    "Мои комиссионные",
    "Доставка, выполненная подчиненными",
    "Выплаты за выполнение задач подчиненных",
    "PCE",
    "Последние 30 дней",
    "Количество",
    "Доставка",
    "Подчиненный",
    "Потребление",
    "Дата"
  ],
  fundRecord: {
    default: [
      "Записи о расходах",
      "Записи о пополнении",
      "Записи о доходах",
      "R",
      "I",
      "E",
      "Записи о снятии",
    ],
    tabs: [
      "Доход",
      "Расход",
      "Пополнение",
      "Снятие"
    ],
    state: [
      'Все',
      'Перезарядка',	//1 recharge
      'Снятие',	//2 withdrawal
      'Разместить задачу',	//3 task
      'Платформенный насос',	//4 pump
      'Скидка',	//5 rebate
      'Доставка завершена',	//6 commission
      'Награды за активность',	//7 regment
      'Реферальные вознаграждения',	//8 spread
      'Обновление',	//9 buymembers
      'Отменить задачу',	//10 revoke
      'Инвестиционный доход',	//11 transfer_c
      'Перевод в инвестиции',	//12 transfer_r
      'Прочие доходы', //13 其他
      'Пожертвовать',	//14
      'Красный конверт',	//15
      'Купить умных роботов',//16
      'Счастливая педаль',//17
      'Возврат средств за VIP-покупку',//18
    ]
  },
  promote: [
    "Ваш лучший друг",
    "Приглашаю вас присоединиться к {title}",
    "Реферальный код",
    "Скопировать код рекомендации",
    "Скопировать ссылку-приглашение",
    "Сохраните QR-код",
    "Поощрения",
    "Сохраните постер успешно", //7
    "Не удалось сохранить постер. Попробуйте ещё несколько раз или сохраните скриншот",
    "Сделайте скриншот",
    "Сохранить рекламный постер",
    "Сохраните рекламный постер на телефон. Если не получится, попробуйте ещё несколько раз или сохраните скриншот",
    "Только официальные партнеры SGM имеют право приглашать друзей присоединиться!",
    "Совместные поездки",
    '<p>1. Награды за совместные поездки: получайте награды за совместные поездки, приглашая новых пользователей присоединиться к SGM.</p><p>2. Комиссионные с продаж: получайте ежедневные комиссионные с продажи велосипедов общего пользования.</p><p>3. Мероприятия компании: компания регулярно проводит различные акции, включая акции «Счастливые педали», «Пароли для поездок» и розыгрыши физических призов.</p><p>4. Накопительные вознаграждения: помогайте компании продавать и сдавать в аренду больше велосипедов общего пользования, чтобы получать денежное вознаграждение, указанное на главной странице SGM. Чем больше велосипедов общего пользования вы пригласите в аренду, тем выше вознаграждение.</p><p>5. Должности в компании: владея определенным количеством велосипедов общего пользования, вы можете подать заявку на должность менеджера по продажам в компании, например, уровня 1, 2, 3 или менеджера по маркетингу, и получать дополнительную ежемесячную зарплату.</p><p>Каждый предоставленный велосипед — это шаг к финансовой свободе; каждая поездка способствует сокращению городских выбросов. SGM помогает вам достичь финансовой свободы, одновременно ведя экологичный образ жизни.</p>',
    "Совместные поездки в команде"
  ],
  teamReport: {
    default: [
      "Поиск",
      "Баланс команды",
      "Преимущества команды",
      "Пополнение счёта команды",
      "Вывод средств командой",
      "Количество первых пополнений",
      "Количество первых отправок",
      "Размер команды",
      "Новая команда",
      "PCE",
      "Я",
      "Пользователь",
      "Пополнение",
      "Выводы",
      "Скидка",
      "Комиссия",
      "Выбрать дату",
      "Нет данных",
      "Сумма выводов",
      "Количество выводов",
      "Скидка на вывод",
      "Количество выводов в команде", //21
      "Партнёр команды",
      "Рекомендуемый общий доход",
      "Общий доход от скидок за доставку",
      "Общее количество выводов в команде уровня 3",
      "Уровень",
      "Родитель",
      "Приглашённые",
      "Список пользователей",
      "Всего пользователей"
    ],
    tabs: [
      "Отчёты команды",
      "Моя команда"
    ],
    team: [
      "Уровень 1",
      "Уровень 2",
      "Уровень 3"
    ]
  },
  help: [
    "Справочное руководство",
    "Недоступно"
  ],
  message: [
    "Просмотреть сообщение",
    "Нет сообщения"
  ],
  credit: [
    "Кредитный рейтинг",
    "Кредитная справка",
    "Кредитная история",
    "<p>Начальный кредитный рейтинг составляет 60 баллов.</p><p>1: Если баллов меньше 50, ежедневный объём доставки уменьшится вдвое.</p><p>2: Балл меньше 30 баллов, и ежедневная доставка не может быть выполнена.</p><p>3: Если баллов меньше 10 баллов, вы не можете подать заявку на снятие наличных.</p><p>Правила начисления баллов: повышение уровня работы добавит 5 баллов, а приглашение подчинённых стать (официальными сотрудниками) — 1 балл.</p><p>Негативное отношение к работе, несвоевременная доставка и нарушение правил компании повлияют на кредитный рейтинг.</p>",
    "Моя кредитная история",
    "В настоящее время кредитной истории нет"
  ],
  dialog: [
    "Советы",
    "Подтвердить",
    "Отправка...",
    "Копирование выполнено успешно",
    "Версия системы iOS низкая и не поддерживается",
    "Регистрация...",
    "Загрузка данных..."
  ],
  lineList: [
    "Выбор линии",
    "Текущая линия",
    "Линия"
  ],
  serviceCenter: [
    "Служба поддержки клиентов",
    "Здравствуйте, эксклюзивная служба поддержки клиентов",
    "Рады вас обслужить.",
    "Самообслуживание",
    "Онлайн-служба поддержки клиентов",
    "Служба поддержки клиентов пополнения баланса",
    "Служба поддержки клиентов онлайн"
  ],
  direct: [
    'СГМ',
    'Бонус роста',
    'Описание деятельности',
    '<p>После прямого приглашения участников на VIP-уровень вы можете получить денежное вознаграждение, если выполните условия!</p><p>Например, если вы пригласите трёх участников VIP-уровня, вы сможете получить вознаграждение напрямую. После этого продолжайте достигать других целей и получать вознаграждение.</p><p>Эксклюзивное вознаграждение за рост от SGM. Каждый сотрудник может получить его только один раз.</p>',
    'Количество подчиненных',
    'Будет закончено',
    'Преимущества приглашения',
    'Получайте награды',
    'Полученный'
  ],
  activity: [
    'Деды Педаль',
    'Подробности',
    'Пожертвовать',
    'Баланс счёта',
    'Всё',
    'Оплатить',
    'Пожалуйста, введите сумму пожертвования',
    'Спасибо за ваше пожертвование'
  ],
  positions: {
    info: ['Подробности позиции', 'Заявка на должность', 'Позиция', 'Команда 3-го уровня, постоянные сотрудники уровня G', 'Соотношение членов команды третьего уровня', 'Зарплата в этом месяце', 'Расчет заработной платы', 'Завершенный', 'Будет завершено', 'Полученный', 'Время получения зарплаты'],
    job: ['Отправить на рассмотрение', 'На рассмотрении', 'Проверено', 'Пожалуйста, загрузите соответствующие документы.', 'Комментарии', 'Нажмите на картинку, чтобы выбрать и загрузить фотографию удостоверения личности.. ', 'Загрузите фотографию лицевой стороны вашего удостоверения личности в поле Фото А.. ', 'Загрузите фотографию обратной стороны вашего удостоверения личности в поле Фото B.. ', 'Загрузите фотографию, на которой вы держите удостоверение личности в руках (Фото C).. ', 'Фото А', 'Фото Б', 'Фото С', 'Пожалуйста, выберите должность, на которую вы хотите получить повышение.', 'Позиция', 'Базовая зарплата', 'Дополнительный бонус', 'Уведомление для сотрудников', 'Я прочитал(а) и согласен(сна) с содержанием «Правил подачи заявлений на должность»', 'Подать заявку на должность', "Пожалуйста, выберите позицию", "Пожалуйста, выберите фото А", "Выберите фото B", "Пожалуйста, выберите фото C"]
  },
}